import { immer } from "utils/zustand.utils"
import create from "zustand"
type SelectorState = {
  selected: Record<string, any>
  resultSet: Record<string, any>[]
  setResultSet: (resultSet: Record<string, any>[]) => void
  selectAll: () => boolean
  toggleSelect: (id: string, value: any) => void
  toggleSelectAll: () => void
  reset: () => void
}
export const createSelectorStore = () => {
  return create<SelectorState>(
    immer((set, get) => ({
      selected: {},
      resultSet: [],
      setResultSet(resultSet) {
        set(draft => {
          draft.resultSet = resultSet
          draft.selected = {}
        })
      },
      selectAll() {
        return Object.keys(get().selected).length === get().resultSet.length
      },
      toggleSelect(id, value) {
        set(draft => {
          if (draft.selected[id]) {
            delete draft.selected[id]
          } else {
            draft.selected[id] = value
          }
        })
      },
      toggleSelectAll() {
        const resultSet = get().resultSet
        set(draft => {
          if (Object.keys(draft.selected).length === resultSet.length) {
            draft.selected = {}
          } else {
            draft.selected = resultSet.reduce(
              (acc, curr) => ({ ...acc, [curr.id]: curr }),
              {}
            )
          }
        })
      },
      reset() {
        set(draft => {
          draft.selected = {}
        })
      },
    }))
  )
}
